<ion-grid class="ion-no-padding">
  <ion-row class="margin-bottom-l">
    <ion-col size="12">
      <getm-category-item
        [categorias]="categorias"
        (selectCategory)="onCategorySelect($event)"
      ></getm-category-item>
    </ion-col>
  </ion-row>
  <ion-row
    *ngIf="activeCategory && agrupadoresFiltered.length > 0"
    class="margin-bottom-s"
  >
    <ion-col size="12">
      <getm-subcategory-item
        [agrupadores]="agrupadoresFiltered"
        [activeAgrupador]="activeAgrupador"
        (selectGrouper)="onAgrupadorSelect($event)"
      ></getm-subcategory-item>
    </ion-col>
  </ion-row>
</ion-grid>
